import { Table } from 'components/table'
import { IPaymentGatewayDTO } from 'data/dtos/commercial/i-payment-gateway-dto'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React, { ChangeEvent, MouseEvent, useEffect, useState } from 'react'
import api from 'services/api'
import { useAlreadyMounted } from 'utils/use-already-mounted'
import { useStyles } from './styles'

const headCells: ITableHeadDTO[] = [
  {
    id: 'name',
    label: 'Nome',
    width: 10,
    type: 'text',
  },
]

const PaymentGatewayList: React.FC = () => {
  const [page, setPage] = useState<number>(0)
  const [search, setSearch] = useState<string>('')
  const [rowsCount, setRowsCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [rowsPerPage, setRowsPerPage] = useState<number>(100)
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])
  const [recordToDelete, setRecordToDelete] = useState<string | null>('')
  const [orderByDirection, setOrderByDirection] = useState<boolean>(true)
  const [paymentGatewaysList, setPaymentGatewaysList] = useState<IPaymentGatewayDTO[]>([])

  const classes = useStyles()
  const alreadyMounted = useAlreadyMounted()

  const loadPaymentGateways = async (isSearch?: boolean) => {
    if (!isSearch) {
      setIsLoading(true)
    }

    await api
      .post('/payment-gateways/list', { search, page, rowsPerPage, columnOrder })
      .then((response) => setPaymentGatewaysList(response.data.data))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    await api
      .post('/payment-gateways/count', { search })
      .then((response) => setRowsCount(response.data.data.count))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    setIsLoading(false)
  }

  const handleDelete = async () => {
    await api
      .delete(`/payment-gateways/${recordToDelete}`)
      .then(async () => await loadPaymentGateways())
      .catch((error) => console.log(error.response?.data))
  }

  const searchChange = (value: string) => {
    setSearch(value)
  }

  const handleClose = () => {
    setModalIsOpen(false)
  }

  const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    event!.preventDefault()
    setPage(newPage)
  }

  const handleChangeRowsPerPage = async (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleCloseDelete = () => {
    setModalIsOpen(false)
    handleDelete()
  }

  const handleDeleteButton = (e: MouseEvent<any, any>, id: string) => {
    e.stopPropagation()
    setModalIsOpen(true)
    setRecordToDelete(id)
  }

  const handleSortChange = (index: number) => {
    columnOrder[index] = columnOrder[index] === 'ASC' ? 'DESC' : 'ASC'

    setColumnOrder(columnOrder)
    setOrderByDirection(!orderByDirection)
  }

  const tabOptions = [
    {
      title: 'Todas',
      size: rowsCount,
      handleClick: () => {},
    },
  ]

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!alreadyMounted) {
        loadPaymentGateways()
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [search])

  useEffect(() => {
    loadPaymentGateways()
  }, [orderByDirection, rowsPerPage, page])

  return (
    <Table.Root>
      <Table.Info
        title='Gateways de Pagamento'
        route='/payment-gateways/new'
        subTitle='Dados coletados sobre gateways de pagamento.'
      />

      <Table.tabs options={tabOptions} />
      <Table.SearchBar
        value={search}
        handleChange={searchChange}
      />

      <Table.Overlay
        isEmpty={paymentGatewaysList.length <= 0}
        isSearch={search.length > 0}
        isLoading={isLoading}
        route='/payment-gateways/new'
        emptyRouteText='Adicionar payment_gateway'
        searchRouteText='Adicionar payment_gateway'
        searchMessage='Nenhum payment_gateway encontrado, você pode criar um novo payment_gateway clicando no botão'
        emptyMessage='Seja bem-vindo à página de gerenciamento de PaymentGatewayss. Até o momento, nenhum payment_gateway foi criado. Para começar, você pode criar um novo payment_gateway clicando no botão'
      >
        <Table.Wrapper
          totalRows={rowsCount}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          page={page}
          handleClose={handleClose}
          handleCloseDelete={handleCloseDelete}
          modalIsOpen={modalIsOpen}
        >
          <Table.Header
            handleSortChange={handleSortChange}
            setOrder={setColumnOrder}
            headCells={headCells}
            order={columnOrder}
          />
          <Table.Body
            handleDeleteButton={handleDeleteButton}
            editRoutePath='/payment-gateways/edit'
            headCells={headCells}
            rows={paymentGatewaysList}
          />
        </Table.Wrapper>
      </Table.Overlay>
    </Table.Root>
  )
}

export default PaymentGatewayList
